import { jsx as _jsx } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { useRef } from 'react';
import { mergeProps, useButton, useFocusRing } from 'react-aria';
const CalendarButton = (props) => {
    const calendarButtonRef = useRef(null);
    const { buttonProps } = useButton(props, calendarButtonRef);
    const { focusProps, isFocusVisible } = useFocusRing();
    return (_jsx("button", { className: buildClassName('flex h-6 w-6 items-center justify-center p-0', 'outline-none hover:cursor-pointer', 'border-none bg-transparent', { '!bg-primary-blue/10': isFocusVisible }), ...mergeProps(buttonProps, focusProps), ref: calendarButtonRef, type: "button", children: props.children }));
};
export default CalendarButton;
//# sourceMappingURL=CalendarButton.js.map